import constants from "../constants";

export const updateDashboardGuideState = (payload) => ({
  type: constants.UPDATE_DASHBOARD_GUIDE_STATE,
  payload,
});
